import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, LinearProgress, Typography, useTheme } from '@mui/material';
import { DamsServices, IDam } from '../../services/api/dams/DamServices';
import { ExpandCircleDown, ExpandMoreOutlined } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { CompanyConsolidated, InstrumentConsolidated, ProjetcConsolidated, UndertakingConsolidated } from '../custom';
import { ILastPaeItem, ILastPaes, PaeServices } from '../../services/api/action-plan/Pae';
import { IReportsRise, ReportsServicesRise, VerificacaoHidrologica } from '../../services/api/reports/ReportsServicesRise';
import { ReportsServicesRisr } from '../../services/api/reports/ReportsServicesRisr';
import { ReportsServicesRpsb, RPSB } from '../../services/api/reports/ReportsServicesRpsb';

interface ConsolidatedCardProps {
    dam_uuid: string
}

export const ConsolidatedCard = ({dam_uuid}: ConsolidatedCardProps) => {

    const [data, setData] = useState<IDam>();
    const [ lastPaes, setLastPaes ] = useState<ILastPaes>();
    const [ rise, setRise ] = useState<IReportsRise>();
    const [ lastType, setLastType ] = useState<string>();

    const [ last, setLast ] = useState<RPSB | IReportsRise>();

    const theme = useTheme();

    useEffect(() => {
        fecthData();
    }, [dam_uuid]);


    const fecthData = () => {
        DamsServices.getById(dam_uuid)
            .then((response => {
                if(response instanceof Error){
                    console.log(response.message);
                }else{
                    setData(response);
                }
            }));
        PaeServices.lastPaes(dam_uuid)
            .then((response => {
                if(response instanceof Error){
                    console.log(response.message);
                }else{
                    setLastPaes(response);
                    const result = getMostRecent(response);
                    if(result?.type && result.uuid){
                        fetchReport(result.type, result.uuid);
                        setLastType(result.type);
                    }
                }
            }));
        ReportsServicesRise.get(dam_uuid)
            .then((response => {
                if(response instanceof Error){
                    console.log(response.message);
                }else{
                    setRise(response);
                }
            }));
    };

    const fetchReport = (type:string, uuid: string) => {
        if(type === 'rise'){
            ReportsServicesRise.get(uuid)
                .then(result => {
                    if(result instanceof Error){
                        console.log(result.message);
                    }else{
                        setLast(result);
                    }
                });
        }else if(type === 'rpsb'){
            ReportsServicesRpsb.get(uuid)
                .then(result => {
                    if(result instanceof Error){
                        console.log(result.message);
                    }else{
                        setLast(result);
                    }
                });
        }
    };   

    const getMostRecent = (data: ILastPaes): { type: string; uuid: string | null } | null => {
        const validTypes = ['rpsb', 'risr']; // Tipos de relatório que você deseja considerar
    
        const mostRecent = data
          .map(item => {
            // Filtrar as entradas que correspondem aos tipos válidos e têm um valor não nulo
            const entry = Object.entries(item).find(([key, value]) => validTypes.includes(key) && value !== null);
            if (entry) {
              const [type, date] = entry as [string, string];
              return { type, date: new Date(date), uuid: item.uuid };
            }
            return null;
          })
          .filter(item => item !== null) as { type: string; date: Date; uuid: string | null }[];
      
        if (mostRecent.length === 0) {
          return null;
        }
      
        const latest = mostRecent.reduce((a, b) => a.date > b.date ? a : b);
        
        return { type: latest.type, uuid: latest.uuid };
    };
    
      

    if(data == undefined){
        return(
            <Box flex={1} padding={1}>
                <LinearProgress/>
            </Box>
        );
    }

    return(
        <Box flex={1} key={data.uuid} justifyContent={'center'} alignContent={'center'}>

            <Box padding={1}>
                <Accordion
                    variant='outlined'
                    square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                >
                    <AccordionSummary
                        expandIcon={<ExpandCircleDown sx={{color: theme.palette.primary.contrastText}}/>}
                    >
                        <Typography>{data.nome}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box gap={1} display={'flex'} flexDirection={'column'}>
                            <CompanyConsolidated uuid={data.id_empresa} key={data.id_empresa}/>
                            <UndertakingConsolidated uuid={data.id_empreendimento} key={data.id_empreendimento}/>
                            <Accordion
                                variant='outlined'
                                square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
                                >
                                    <Typography><strong>Dados gerais da estrutura</strong></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Finalidade:</Typography>
                                        <Typography>{data.proposito}</Typography>
                                    </Box>
                                    <Divider/>    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Situação operacional:</Typography>
                                        <Typography>{data.status_operacional}</Typography>
                                    </Box>
                                    <Divider/>    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Decreto minerário (ANM):</Typography>
                                        <Typography>{data.anm}</Typography>
                                    </Box>
                                    <Divider/>    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Início de operação:</Typography>
                                        <Typography>{data.inicio_operacao}</Typography>
                                    </Box>
                                    <Divider/>    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Fim de vida últio:</Typography>
                                        <Typography>{data.fim_operacao}</Typography>
                                    </Box>
                                    <Divider/>    
                                    <Box flex={1} flexDirection={'column'} display={'flex'} gap={1}>
                                        <Typography>Coordenadas geográficas</Typography>
                                        <Box display={'flex'} flexDirection={'row'} gap={1}>
                                            <Typography>Latitude:</Typography>
                                            <Typography>{data.latitude}</Typography>
                                        </Box>
                                        <Box display={'flex'} flexDirection={'row'} gap={1}>
                                            <Typography>Longitude:</Typography>
                                            <Typography>{data.longitude}</Typography>
                                        </Box>
                                    </Box>
                                    <Divider/> 
                                    <Box flex={1} flexDirection={'column'} display={'flex'} gap={1}>
                                        <Typography>Coordenadas UTM</Typography>
                                        <Box display={'flex'} flexDirection={'row'} gap={1}>
                                            <Typography>UTM EW:</Typography>
                                            <Typography>{data.utm_ew}</Typography>
                                        </Box>
                                        <Box display={'flex'} flexDirection={'row'} gap={1}>
                                            <Typography>UTM NS:</Typography>
                                            <Typography>{data.utm_ns}</Typography>
                                        </Box>
                                        <Box display={'flex'} flexDirection={'row'} gap={1}>
                                            <Typography>Zona UTM:</Typography>
                                            <Typography>{data.utm_zone}</Typography>
                                        </Box>
                                    </Box>
                                    <Divider/>
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Datum:</Typography>
                                        <Typography>{data.timezone}</Typography>
                                    </Box>
                                    <Divider/> 
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Órgão fiscalizador:</Typography>
                                        <Typography>{data.agencia_reguladora}</Typography>
                                    </Box>
                                    <Divider/> 
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                variant='outlined'
                                square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
                                >
                                    <Typography><strong>Classificação</strong></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Documento de Referência: {lastType}</Typography>
                                    </Box> 
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Empresa elaboradora:</Typography>
                                        <Typography>{last?.empresa_executora}</Typography>
                                    </Box>
                                    <Divider/>                                   
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Ano de elaboração:</Typography>
                                        <Typography>{last?.data_inspecao}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Área de drenagem (km²): </Typography>
                                        <Typography>{last?.verificacaoHidrologica?.area_drenagem}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Precipitação TR 10.000 ou PMP? </Typography>
                                        <Typography>{last?.verificacaoHidrologica?.precipitacao_pmp}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Precipitação de projeto (mm): </Typography>
                                        <Typography>{last?.verificacaoHidrologica?.precipitacao_projeto}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Duração crítica da chuva de projeto (min): </Typography>
                                        <Typography>{last?.verificacaoHidrologica?.duracao_chuva}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Vazão máxima afluente (m³/s): </Typography>
                                        <Typography>{last?.verificacaoHidrologica?.vazao_maxima}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>NA máximo operacional (m): </Typography>
                                        <Typography>{last?.verificacaoHidrologica?.na_maximo_operacional}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>NA máximo maximorum (m): </Typography>
                                        <Typography>{last?.verificacaoHidrologica?.na_maximo_maximorum}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Borda livre (m): </Typography>
                                        <Typography>{last?.verificacaoHidrologica?.borda_livre}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                variant='outlined'
                                square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
                                >
                                    <Typography><strong>Condição de estabilidade</strong></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        
                                    </Box>
                                    <Divider/>                                    
                                </AccordionDetails>
                            </Accordion>
                            <ProjetcConsolidated uuid={data.uuid}/>
                            <Accordion
                                variant='outlined'
                                square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
                                >
                                    <Typography><strong>Características técnicas</strong></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Elevação da crista :</Typography>
                                        <Typography>{data.elevacao_crista}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Comprimento da crista :</Typography>
                                        <Typography>{data.comprimento_crista}</Typography>
                                    </Box>
                                    <Divider/> 
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Altura máxima da crista :</Typography>
                                        <Typography>{data.altura_maxima_crista}</Typography>
                                    </Box>
                                    <Divider/> 
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Inclinação do talude de montante : </Typography>
                                        <Typography>{data.inclinacao_talude_montante}</Typography>
                                    </Box>
                                    <Divider/> 
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Inclinação do talude de jusante :</Typography>
                                        <Typography>{data.inclinacao_talude_jusante}</Typography>
                                    </Box>
                                    <Divider/> 
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Bermas :</Typography>
                                        <Typography>{data.berma}</Typography>
                                    </Box>
                                    <Divider/> 
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Volume da estrutura (m³) :</Typography>
                                        <Typography>{data.volume_estrutura}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Área da estrutura (m²) :</Typography>
                                        <Typography>{data.area_estrutura}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Volume do maciço (m³) :</Typography>
                                        <Typography>{data.area_estrutura}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Composição do maciço :</Typography>
                                        <Typography>{data.composicao_macico}</Typography>
                                    </Box>
                                    <Divider/>    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Sistemas de drenagem :</Typography>
                                        <Typography>{data.sistema_dranagem}</Typography>
                                    </Box>
                                    <Divider/>                             
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Extravasor :</Typography>
                                        <Typography>{data.extravasor}</Typography>
                                    </Box>
                                    <Divider/>                             
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Impermeabilização :</Typography>
                                        <Typography>{data.impermeablizacao}</Typography>
                                    </Box>
                                    <Divider/>                             
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Fundação :</Typography>
                                        <Typography>{data.fundacao}</Typography>
                                    </Box>
                                    <Divider/>                             
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Curso da água interceptado/barrado :</Typography>
                                        <Typography>{data.curso_dagua_barrado}</Typography>
                                    </Box>
                                    <Divider/>                             
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Vazão residual do curso da água :</Typography>
                                        <Typography>{data.vazao_residual_curso_dagua}</Typography>
                                    </Box>
                                    <Divider/>                             
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                variant='outlined'
                                square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
                                >
                                    <Typography><strong>Características operacionais</strong></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Processo de beneficiamento:</Typography>
                                        <Typography>{data.processo_beneficiamento}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Protudos químicos:</Typography>
                                        <Typography>{data.produtos_quimicos}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Rejeito contém cianeto:</Typography>
                                        <Typography>{data.rejeito_cianeto}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Mineral principal presente no rejeito:</Typography>
                                        <Typography>{data.mineral_presente_rejeito}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Teor(%) do mineral principal:</Typography>
                                        <Typography>{data.teor_mineral_rejeito}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Teor(%) de outros minerais:</Typography>
                                        <Typography>{data.teor_outros_mineral_rejeito}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Densidade específica do rejeito (t/m³):</Typography>
                                        <Typography>{data.densidade_rejeito}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Geração de rejeitos (t/mês):</Typography>
                                        <Typography>{data.geracao_rejeito}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Teor (%) de sólidos na polpa:</Typography>
                                        <Typography>{data.teor_solidos_polpa}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                </AccordionDetails>
                            </Accordion>
                            <InstrumentConsolidated data={data.instrumentos} />
                            <Accordion
                                variant='outlined'
                                square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
                                >
                                    <Typography><strong>Hidrologia / Hidráulica</strong></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Documento de Referência: {lastType}</Typography>
                                    </Box>                               
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Empresa elaboradora: </Typography>
                                        <Typography>{rise?.empresa_executora}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Data DCE: </Typography>
                                        <Typography>{rise?.data_dce}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>Precipitação TR 10.000 ou PMP?:</Typography>
                                        <Typography>{rise?.cri}</Typography>
                                    </Box>
                                    <Divider/>                                    
                                </AccordionDetails>
                            </Accordion>
                            {/* <Accordion
                                variant='outlined'
                                square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
                                >
                                    <Typography><strong>Últimos relatórios</strong></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>PAE:</Typography>
                                        <Typography>
                                            {lastPaes && lastPaes[3]?.pae ? new Date(lastPaes[3].pae).toLocaleDateString() : '---'}
                                        </Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection="row" display="flex" gap={1}>
                                        <Typography>ACO:</Typography>
                                        <Typography>
                                            {lastPaes && lastPaes[5]?.aco ? new Date(lastPaes[5].aco).toLocaleDateString() : '---'}
                                        </Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>RISE:</Typography>
                                        <Typography>
                                            {lastPaes && lastPaes[0]?.rise ? new Date(lastPaes[0].rise).toLocaleDateString() : '---'}
                                        </Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>RISR:</Typography>
                                        <Typography>
                                            {lastPaes && lastPaes[1]?.risr ? new Date(lastPaes[1].risr).toLocaleDateString() : '---'}
                                        </Typography>
                                    </Box>
                                    <Divider/>                                    
                                    <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                                        <Typography>RPSB:</Typography>
                                        <Typography>
                                            {lastPaes && lastPaes[2]?.rpsb ? new Date(lastPaes[2].rpsb).toLocaleDateString() : '---'}
                                        </Typography>
                                    </Box>
                                    <Divider/>                                    
                                </AccordionDetails>
                            </Accordion> */}
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Box>

        </Box>
    );
};